module.exports = __webpack_public_path__ + "static/yalda-needle-e0f76d26ebd4aa6bcd3c2ccc7ea91354.jpg";